import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map, take } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@angular/forms';
import { Validators, ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import * as errorUtils from 'error-message-utility';
import { SendNotificationComponent } from 'send-notification';
import * as RolesRouteMap from 'app-models';
import * as i2 from 'common-quetions';
import * as i4 from '@angular/router';
import * as i5 from 'primeng/dynamicdialog';
import * as i6 from '@angular/common';
import * as i7 from '@angular/material/slide-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import * as i8 from 'primeng/dropdown';
import * as i9 from 'primeng/radiobutton';
import * as i10 from 'primeng/inputswitch';
import * as i11 from 'primeng/checkbox';
import { PrimengLibraryModule } from 'primeng-library';

class VdSubTaskH4Service {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.isPetitionOutsideImagility = new BehaviorSubject(false);
    }
    getDependentList(beneficiary_id) {
        return this.httpClient.get(`/vd/beneficiary/${beneficiary_id}/dependentDetails`).pipe(map(response => {
            return response['data'];
        }));
    }
    getSponsorList(attorneyId) {
        return this.httpClient.post(`/attorney/${attorneyId}/beneficiaries/list`, {}).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
            else {
                return null;
            }
        }));
    }
    getBeneficiariesByCompanyId(companyId) {
        return this.httpClient.get(`/petitioner/dashboard/beneficiaries/company/associated/${companyId}/list`).pipe(map((response) => {
            if (response.status === 200 && response.data) {
                return response.data;
            }
            else {
                return [];
            }
        }));
    }
    getSubTaskTypeListForFamilyImmigration(superTaskTypeCode, immgCategoryCode, immgClassificationCode) {
        return this.httpClient
            .get(`/task/superTask/${superTaskTypeCode}/taskTypes?immCat=${immgCategoryCode}&immClas=${immgClassificationCode}`)
            .pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
            else {
                return null;
            }
        }));
    }
}
VdSubTaskH4Service.ɵfac = function VdSubTaskH4Service_Factory(t) { return new (t || VdSubTaskH4Service)(i0.ɵɵinject(i1.HttpClient)); };
VdSubTaskH4Service.ɵprov = i0.ɵɵdefineInjectable({ token: VdSubTaskH4Service, factory: VdSubTaskH4Service.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdSubTaskH4Service, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function VdSubTaskH4Component_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelementStart(2, "label", 7);
    i0.ɵɵtext(3, "Sub - Task type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 8);
    i0.ɵɵelementStart(5, "b");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "div", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r0.subTaskDetails.subTaskTypeCode ? ctx_r0.subTaskDetails.subTaskTypeCode.toLowerCase() : "");
} }
function VdSubTaskH4Component_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
} }
function VdSubTaskH4Component_div_2_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵtext(2, " Do you want to duplicate data from previous petition? ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 14);
    i0.ɵɵelementStart(4, "mat-slide-toggle", 15);
    i0.ɵɵlistener("change", function VdSubTaskH4Component_div_2_div_8_Template_mat_slide_toggle_change_4_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return ctx_r7.isDuplicatedtoggle("duplicated", $event.checked); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function VdSubTaskH4Component_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementStart(1, "h5", 11);
    i0.ɵɵtext(2, "Choose from the options below");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 12);
    i0.ɵɵelementStart(4, "div", 13);
    i0.ɵɵtext(5, " Is Petition Filed Outside Imagility ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 14);
    i0.ɵɵelementStart(7, "mat-slide-toggle", 15);
    i0.ɵɵlistener("change", function VdSubTaskH4Component_div_2_Template_mat_slide_toggle_change_7_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.isDuplicatedtoggle("idx", $event.checked); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, VdSubTaskH4Component_div_2_div_8_Template, 5, 0, "div", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngIf", ctx_r2.isDuplicatedData === "true");
} }
function VdSubTaskH4Component_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
} }
function VdSubTaskH4Component_div_4_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelementStart(1, "div", 21);
    i0.ɵɵelementStart(2, "label", 22);
    i0.ɵɵtext(3, "Sub-Task Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "p-dropdown", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r11.subTaskType);
} }
function VdSubTaskH4Component_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelementStart(1, "h5", 18);
    i0.ɵɵtext(2, "Enter the Sub-Task Details ");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, VdSubTaskH4Component_div_4_div_3_Template, 5, 1, "div", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r4.form.get("subTask").get("isOutsideImagility").value || ctx_r4.isImmigrant);
} }
function VdSubTaskH4Component_div_5_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelementStart(1, "label", 31);
    i0.ɵɵtext(2, "Dependents not added in beneficiary profile?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵelementStart(4, "a", 32);
    i0.ɵɵlistener("click", function VdSubTaskH4Component_div_5_div_1_div_5_Template_a_click_4_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(3); return ctx_r16.notifyBeneficiary(); });
    i0.ɵɵtext(5, "Notify Beneficiary");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6, " or ");
    i0.ɵɵelementStart(7, "a", 32);
    i0.ɵɵlistener("click", function VdSubTaskH4Component_div_5_div_1_div_5_Template_a_click_7_listener() { i0.ɵɵrestoreView(_r17); const ctx_r18 = i0.ɵɵnextContext(3); return ctx_r18.visitBeneficiaryProfile(); });
    i0.ɵɵtext(8, "Visit Profile");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function VdSubTaskH4Component_div_5_div_1_small_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 33);
    i0.ɵɵtext(1, " No Dependents Added. ");
    i0.ɵɵelementEnd();
} }
function VdSubTaskH4Component_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "div", 21);
    i0.ɵɵelementStart(2, "label", 26);
    i0.ɵɵtext(3, "Select Primary Applicant");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p-dropdown", 27);
    i0.ɵɵlistener("onChange", function VdSubTaskH4Component_div_5_div_1_Template_p_dropdown_onChange_4_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(2); return ctx_r19.handlePrimaryApplicantChange(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, VdSubTaskH4Component_div_5_div_1_div_5_Template, 9, 0, "div", 28);
    i0.ɵɵelementStart(6, "div", 21);
    i0.ɵɵtemplate(7, VdSubTaskH4Component_div_5_div_1_small_7_Template, 2, 0, "small", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r12.dependentList);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(ctx_r12.subTaskDetails == null ? null : ctx_r12.subTaskDetails.isBeneficiaryIntiate));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r12.dependentList && ctx_r12.dependentList.length === 0);
} }
function VdSubTaskH4Component_div_5_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵelementStart(1, "div", 36);
    i0.ɵɵelementStart(2, "label", 26);
    i0.ɵɵtext(3, "No.of Applicants Part Of this petition");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 37);
    i0.ɵɵelementStart(5, "div", 38);
    i0.ɵɵelementStart(6, "p-radioButton", 39);
    i0.ɵɵlistener("onClick", function VdSubTaskH4Component_div_5_div_2_div_1_Template_p_radioButton_onClick_6_listener() { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(3); return ctx_r24.onChangeNoOfApplicant("single"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "label", 40);
    i0.ɵɵtext(8, "Single");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 38);
    i0.ɵɵelementStart(10, "p-radioButton", 41);
    i0.ɵɵlistener("onClick", function VdSubTaskH4Component_div_5_div_2_div_1_Template_p_radioButton_onClick_10_listener() { i0.ɵɵrestoreView(_r25); const ctx_r26 = i0.ɵɵnextContext(3); return ctx_r26.onChangeNoOfApplicant("multiple"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "label", 42);
    i0.ɵɵtext(12, "Multiple");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function VdSubTaskH4Component_div_5_div_2_div_2_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelementStart(1, "p-inputSwitch", 45);
    i0.ɵɵlistener("onChange", function VdSubTaskH4Component_div_5_div_2_div_2_div_1_div_3_Template_p_inputSwitch_onChange_1_listener() { i0.ɵɵrestoreView(_r30); const ctx_r29 = i0.ɵɵnextContext(5); return ctx_r29.handleSpouseSwitchChange(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function VdSubTaskH4Component_div_5_div_2_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵelementStart(1, "div", 43);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, VdSubTaskH4Component_div_5_div_2_div_2_div_1_div_3_Template, 2, 0, "div", 44);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r27.questionLabelText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r27.field.showApplicantSwitch);
} }
function VdSubTaskH4Component_div_5_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, VdSubTaskH4Component_div_5_div_2_div_2_div_1_Template, 4, 2, "div", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(3);
    let tmp_0_0 = null;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r22.form.controls["newTaskForm"] == null ? null : (tmp_0_0 = ctx_r22.form.controls["newTaskForm"].get("taskType")) == null ? null : tmp_0_0.value) === "IMMPET");
} }
function VdSubTaskH4Component_div_5_div_2_div_3_label_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 50);
    i0.ɵɵtext(1, "I am filing this form for");
    i0.ɵɵelementEnd();
} }
function VdSubTaskH4Component_div_5_div_2_div_3_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 51);
    i0.ɵɵelementStart(2, "div", 52);
    i0.ɵɵelement(3, "p-checkbox", 53);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const x_r33 = ctx.$implicit;
    const i_r34 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", i_r34);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("label", x_r33.displayName)("name", x_r33.displayName)("disabled", x_r33.isPrimaryApplicant);
} }
function VdSubTaskH4Component_div_5_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, VdSubTaskH4Component_div_5_div_2_div_3_label_1_Template, 2, 0, "label", 46);
    i0.ɵɵelementStart(2, "div", 47);
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵelementStart(4, "div", 48);
    i0.ɵɵtemplate(5, VdSubTaskH4Component_div_5_div_2_div_3_ng_container_5_Template, 4, 4, "ng-container", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(3);
    let tmp_0_0 = null;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r23.form.controls["newTaskForm"] == null ? null : (tmp_0_0 = ctx_r23.form.controls["newTaskForm"].get("immClassificationCode")) == null ? null : tmp_0_0.value) != "AFFDVTSUPT864");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r23.dependentList);
} }
function VdSubTaskH4Component_div_5_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, VdSubTaskH4Component_div_5_div_2_div_1_Template, 13, 0, "div", 34);
    i0.ɵɵtemplate(2, VdSubTaskH4Component_div_5_div_2_div_2_Template, 2, 1, "div", 25);
    i0.ɵɵtemplate(3, VdSubTaskH4Component_div_5_div_2_div_3_Template, 6, 2, "div", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    let tmp_0_0 = null;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r13.form.controls["newTaskForm"] == null ? null : (tmp_0_0 = ctx_r13.form.controls["newTaskForm"].get("taskType")) == null ? null : tmp_0_0.value) != "IMMPET");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.field.showApplicantDetailSection);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.showFillingFormSection);
} }
function VdSubTaskH4Component_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, VdSubTaskH4Component_div_5_div_1_Template, 8, 3, "div", 0);
    i0.ɵɵtemplate(2, VdSubTaskH4Component_div_5_div_2_Template, 4, 3, "div", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.field.showPrimaryApplicantSection);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.field.showApplicantDetailSection);
} }
class VdSubTaskH4Component {
    constructor(fb, apiService, vdSubTaskH4Service, parentFor, router, dialogService) {
        this.fb = fb;
        this.apiService = apiService;
        this.vdSubTaskH4Service = vdSubTaskH4Service;
        this.parentFor = parentFor;
        this.router = router;
        this.dialogService = dialogService;
        this.field = {
            showOutsideImagilityQuestion: true,
            showPrimaryApplicantSection: true,
            showApplicantDetailSection: true,
            //  showIncludeSpouseChildQn: true,
            showApplicantSwitch: true,
        };
        this.dependentList = [];
        this.showFillingFormSection = false;
        this.beneficiaryList = [];
        this.getValueAutopopulateTemplate = false;
        this.subTaskDetails = null;
        this.showSubTaskTypeInReadOnly = true;
    }
    ngOnInit() {
        // this.fieldConfigurations = [
        //   {
        //     "label": "outside imagility",
        //     "fieldName": "showOutsideImagilityQuestion",
        //     "showField": true,
        //     "fieldType": "inputSwitch",
        //     "value": "test1"
        //   },
        //   {
        //     "label": "primary applicant",
        //     "fieldName": "showPrimaryApplicantSection",
        //     "showField": true,
        //     "fieldType": "inputSwitch",
        //     "value": "test1",
        //     "dependentList": ['CHILD', 'FATHER']
        //   },
        //   {
        //     "label": "applicant Detail",
        //     "fieldName": "showApplicantDetailSection",
        //     "showField": true,
        //     "fieldType": "inputSwitch",
        //     "questionLabelText": "Do you want to include Spouse and Children in this petition?",
        //     "enableSwitch": true,
        //     "showPrimaryApplicantToo": false,
        //   },
        //   {
        //     "label": "Show Include Spouse & Children Question in the applicant detail",
        //     "fieldName": "showIncludeSpouseChildQn",
        //     "showField": true,
        //     "fieldType": "inputSwitch",
        //     "value": "test1"
        //   }
        // ],
        try {
            this.isDuplicatedData = sessionStorage.getItem('isDuplicated');
            this.apiService.isAutoPopulateTemplate.subscribe((res) => {
                this.getValueAutopopulateTemplate = res;
            });
            this.primaryCompanyId = parseInt(sessionStorage.getItem('companyId'));
            this.userType = sessionStorage.getItem('userTypeRole');
            this.setFieldConfiguration();
            this.userType = sessionStorage.getItem('userTypeRole');
            this.immigrantType = 'VISA';
            if (this.subTaskDetails && this.subTaskDetails.superTaskTypeCode) {
                this.superTaskTypeCode = this.subTaskDetails.superTaskTypeCode;
            }
            this.form = this.parentFor.form;
            this.createForm();
            // try {
            this.form.controls['newTaskForm'].controls['beneficiaryId'].valueChanges.subscribe((data) => {
                this.resetDependentsValues();
                if (this.form.controls['newTaskForm'].controls['beneficiaryId'].value) {
                    this.vdSubTaskH4Service.getDependentList(this.form.controls['newTaskForm'].controls['beneficiaryId'].value)
                        .pipe(take(1))
                        .subscribe((response) => {
                        var _a;
                        this.dependentList = response.map(x => {
                            return Object.assign(Object.assign({}, x), { displayName: `${x.firstName} ${x.lastName} - ${x.relationshipName}`, isChecked: false, isPrimaryApplicant: false });
                        });
                        const configDependentList = (_a = this.fieldConfiguration) === null || _a === void 0 ? void 0 : _a.find(e => e.fieldName == "showPrimaryApplicantSection");
                        if (configDependentList && configDependentList.dependentList && configDependentList.dependentList.length > 0) {
                            this.dependentList = this.dependentList.filter(item => configDependentList.dependentList.includes(item.relationshipCode));
                        }
                        else {
                            if (this.form.controls['newTaskForm'].controls['visaType'].value === 'K1') {
                                this.dependentList = this.dependentList.filter(item => item.relationshipCode === 'FIANCE');
                            }
                            else if (this.form.controls['newTaskForm'].controls['visaType'].value === 'K3') {
                                this.dependentList = this.dependentList.filter(item => item.relationshipCode === 'SPOUSE');
                            }
                            else if (this.form.controls['newTaskForm'].controls['immCategoryCode'].value && this.form.controls['newTaskForm'].controls['immCategoryCode'].value === 'GCFLY') {
                                if (this.form.controls['newTaskForm'].controls['immClassificationCode'].value === 'REMVCONDTRES') {
                                    this.dependentList = this.dependentList.filter(item => ['SPOUSE', 'CHILD'].includes(item.relationshipCode));
                                }
                                else {
                                    this.dependentList = this.dependentList;
                                }
                            }
                            else if (this.form.controls['newTaskForm'].controls['immClassificationCode'].value &&
                                ['WVRUNLAWPRSNCI601A', 'WVRINADMI601', 'AFFDVTSUPT864'].includes(this.form.controls['newTaskForm'].controls['immClassificationCode'].value)) {
                                this.dependentList = this.dependentList;
                            }
                            else if (['U1', 'UD'].includes(this.form.controls['newTaskForm'].controls['visaType'].value)) {
                                this.dependentList = this.dependentList.filter(item => item.relationshipCode !== 'FIANCE');
                            }
                            else {
                                this.dependentList = this.dependentList.filter(item => ['SPOUSE', 'CHILD'].includes(item.relationshipCode));
                            }
                        }
                        if (this.subTaskDetails && this.field.showApplicantDetailSection) {
                            this.addQuestioneryText();
                        }
                        //  if(DEPENDENT_VISAS.includes(this.form.controls['newTaskForm'].controls['visaType'].value) && this.form.controls['newTaskForm'].controls['visaType'].value !== 'K1' && this.form.controls['newTaskForm'].controls['visaType'].value !== 'K3'){
                        //  this.dependentList = this.dependentList.filter(item => ['SPOUSE','CHILD'].includes(item.relationshipCode));
                        //  }
                        this.addFilingThisFormControl();
                        // if(this.form.controls['newTaskForm'].controls['taskType'].value === 'IMMPET'){
                        //   this.clearValidatorForApplicant()
                        // }
                        // this.dependentList = response;
                    });
                }
                else {
                    this.resetDependentsValues();
                    // jsGroup.addControl('isSingleApplicant', this.fb.control(null));
                }
            });
            //  }
            // catch (error) {
            // };
            this.form.controls['newTaskForm'].controls['companyId'].valueChanges.subscribe((data) => {
                if (this.form.controls['newTaskForm'].controls['companyId'].value) {
                    this.getBeneficiaryList((this.form.controls['newTaskForm'].controls['companyId'].value));
                }
                else {
                    this.getSponsorList();
                }
            });
            if (this.form.get('subTask.isOutsideImagility')) {
                this.form.get('subTask.isOutsideImagility').valueChanges.subscribe((data) => {
                    this.handleSwitchChange();
                });
            }
            this.form.controls['newTaskForm'].controls['immClassificationCode'].valueChanges.subscribe((data) => {
                this.addQuestioneryText();
            });
        }
        catch (error) {
            console.log(error);
        }
    }
    addQuestioneryText() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.questionLabelText = "";
        let applicant;
        if (this.fieldConfiguration) {
            applicant = this.fieldConfiguration.find(e => e.fieldName == "showApplicantDetailSection");
        }
        if (this.fieldConfiguration && applicant && applicant.questionLabelText && applicant.questionLabelText !== "") {
            this.questionLabelText = applicant.questionLabelText;
        }
        else {
            if (this.form.controls['newTaskForm'].controls['immClassificationCode'].value != 'AFFDVTSUPT864' &&
                this.form.controls['newTaskForm'].controls['immClassificationCode'].value != 'ASYLRELATIVE') {
                this.questionLabelText = 'Do you want to include Spouse and Children in this petition?';
            }
            else if (((_b = (_a = this.form.controls['newTaskForm']) === null || _a === void 0 ? void 0 : _a.get('immClassificationCode')) === null || _b === void 0 ? void 0 : _b.value) === 'AFFDVTSUPT864') {
                this.questionLabelText = 'Do you want to include Household members who support the principal immigrant ?';
            }
        }
        if (this.fieldConfiguration && applicant && applicant.enableSwitch && applicant.enableSwitch !== null) {
            this.field.showApplicantSwitch = applicant.enableSwitch;
        }
        else {
            if (((_d = (_c = this.form.controls['newTaskForm']) === null || _c === void 0 ? void 0 : _c.get('immClassificationCode')) === null || _d === void 0 ? void 0 : _d.value) &&
                ((_f = (_e = this.form.controls['newTaskForm']) === null || _e === void 0 ? void 0 : _e.get('immClassificationCode')) === null || _f === void 0 ? void 0 : _f.value) != 'ASYLRELATIVE') {
                this.field.showApplicantSwitch = true;
            }
            else {
                if (((_h = (_g = this.form.controls['newTaskForm']) === null || _g === void 0 ? void 0 : _g.get('immClassificationCode')) === null || _h === void 0 ? void 0 : _h.value) === 'ASYLRELATIVE') {
                    this.field.showApplicantSwitch = false;
                }
            }
        }
    }
    setFieldConfiguration() {
        if (this.fieldConfiguration && this.fieldConfiguration.length > 0) {
            this.field.showOutsideImagilityQuestion = this.objExists('showOutsideImagilityQuestion');
            this.field.showPrimaryApplicantSection = this.objExists('showPrimaryApplicantSection');
            this.field.showApplicantDetailSection = this.objExists('showApplicantDetailSection');
            // this.field.showIncludeSpouseChildQn = this.objExists('showIncludeSpouseChildQn');
        }
    }
    objExists(name) {
        return this.fieldConfiguration.some(function (el) {
            if (el.fieldName === name) {
                return el.showField;
            }
        });
    }
    getSponsorList() {
        this.vdSubTaskH4Service.getSponsorList(this.primaryCompanyId)
            .pipe(take(1))
            .subscribe(data => {
            if (data && data.beneficiaryList && data.beneficiaryList.length > 0) {
                this.beneficiaryList = data.beneficiaryList;
            }
        });
    }
    createForm() {
        // this.subTask = this.fb.group({
        //   isOutsideImagility: [false],
        //   taskTypeCode: [null, Validators.required],
        //   familyId:[''],
        //   numberOfApplicant:[''],
        //   applicantsList:this.fb.array([],[Validators.required]),
        //  // CommonTaskQuestions: this.fb.array([])
        // })
        this.subTask = this.fb.group({});
        const jsGroup = this.form.get('jsonInput');
        if (this.field.showOutsideImagilityQuestion) {
            this.subTask.addControl('isOutsideImagility', this.fb.control(false));
            this.subTask.addControl('taskTypeCode', this.fb.control(null));
        }
        if (this.field.showPrimaryApplicantSection && jsGroup) {
            jsGroup.addControl('primaryApplicant', this.fb.control(null, [Validators.required]));
            if (!(jsGroup.get('applicantsList'))) {
                jsGroup.addControl('applicantsList', this.fb.array([]));
            }
        }
        if (this.field.showApplicantDetailSection && jsGroup) {
            //  try {
            jsGroup.addControl('isSingleApplicant', this.fb.control(null));
            jsGroup.addControl('isSpouseChildPetitionInclude', this.fb.control(false));
            if (!(jsGroup.get('applicantsList'))) {
                jsGroup.addControl('applicantsList', this.fb.array([]));
            }
            // if (this.field.showIncludeSpouseChildQn) {
            //   jsGroup.get('isSpouseChildPetitionInclude').setValue(true);
            //   this.showFillingFormSection = true;
            // }
            // if(this.form.get('newTaskForm.taskType').value === 'IMMPET'){
            //   jsGroup.addControl('applicantsList', this.fb.array([]));
            // }else{
            //   jsGroup.addControl('applicantsList', this.fb.array([])); //need to check remove validator it will break other dependent Visa & K1 Visa
            // }
            // } catch (error) {
            // }
            // this.addFilingThisFormControl();
        }
        this.form.addControl('subTask', this.subTask);
        // this.getQuestions();
        this.isImmigrant = this.superTaskTypeCode === 'IMMPET' ? true : false;
        this.getSubTaskType();
    }
    clearValidatorForApplicant() {
        const jsGroup = this.form.get('jsonInput');
        if (jsGroup) {
            jsGroup.get('applicantsList').clearValidators();
            jsGroup.updateValueAndValidity();
        }
    }
    addFilingThisFormControl() {
        var _a, _b, _c;
        const jsGroup = this.form.get('jsonInput');
        let initiateArray;
        if (jsGroup) {
            initiateArray = jsGroup.get('applicantsList');
        }
        initiateArray.clear();
        if (this.dependentList && this.dependentList.length > 0) {
            let jsonInputSaved;
            if (this.subTaskDetails && this.subTaskDetails.jsonInput) {
                jsonInputSaved = JSON.parse(this.subTaskDetails.jsonInput);
                const primaryApplicant = (jsonInputSaved === null || jsonInputSaved === void 0 ? void 0 : jsonInputSaved.primaryApplicant) ? this.dependentList.find((dep) => dep.id === jsonInputSaved.primaryApplicant.id) : null;
                if (primaryApplicant) {
                    (_a = jsGroup.get('primaryApplicant')) === null || _a === void 0 ? void 0 : _a.setValue(primaryApplicant);
                    (_b = jsGroup.get('primaryApplicant')) === null || _b === void 0 ? void 0 : _b.updateValueAndValidity();
                }
                const isSingleApplicant = (jsonInputSaved === null || jsonInputSaved === void 0 ? void 0 : jsonInputSaved.isSingleApplicant) ? jsonInputSaved === null || jsonInputSaved === void 0 ? void 0 : jsonInputSaved.isSingleApplicant : null;
                if (isSingleApplicant == 'true') {
                    jsGroup.get('isSingleApplicant').setValue('true');
                    this.onChangeNoOfApplicant('single');
                    jsGroup.get('isSingleApplicant').updateValueAndValidity();
                }
                else if (isSingleApplicant == 'false') {
                    jsGroup.get('isSingleApplicant').setValue('false');
                    this.onChangeNoOfApplicant('multiple');
                }
                if (jsonInputSaved) {
                    if (jsonInputSaved.isSpouseChildPetitionInclude) {
                        jsGroup.get('isSpouseChildPetitionInclude').setValue(jsonInputSaved.isSpouseChildPetitionInclude);
                        jsGroup.get('isSpouseChildPetitionInclude').updateValueAndValidity();
                        this.handleSpouseSwitchChange();
                    }
                }
            }
            this.dependentList.forEach((x, index) => {
                var _a;
                if (jsonInputSaved && ((jsonInputSaved.primaryApplicant && x.id === jsonInputSaved.primaryApplicant.id) || ((_a = jsonInputSaved === null || jsonInputSaved === void 0 ? void 0 : jsonInputSaved.applicantsList) === null || _a === void 0 ? void 0 : _a.some(y => y.id === x.id)))) {
                    x.isChecked = true;
                }
                const formGroup = this.createApplicantList(x);
                initiateArray.push(formGroup);
            });
            if ((_c = jsGroup.get('primaryApplicant')) === null || _c === void 0 ? void 0 : _c.value) {
                this.handlePrimaryApplicantChange();
            }
        }
    }
    createApplicantList(item) {
        return this.fb.group({
            id: item.id,
            firstName: item.firstName,
            lastName: item.lastName,
            middleName: item.middleName,
            relationshipName: item.relationshipName,
            relationshipCode: item.relationshipCode,
            isChecked: item.isChecked,
            isPrimaryApplicant: item.isPrimaryApplicant
        });
    }
    resetDependentsValues() {
        this.dependentList = [];
        const jsGroup = this.form.get('jsonInput');
        if (jsGroup && jsGroup.contains('isSingleApplicant')) {
            jsGroup.patchValue({ isSingleApplicant: null });
            jsGroup.patchValue({ isSpouseChildPetitionInclude: false });
        }
        this.showFillingFormSection = false;
        // if (this.field.showIncludeSpouseChildQn) {
        //   jsGroup.patchValue({ isSpouseChildPetitionInclude: true });
        //   this.showFillingFormSection = true;
        // }
    }
    handlePrimaryApplicantChange() {
        const selectedValue = this.form.get('jsonInput.primaryApplicant').value;
        const jsGroup = this.form.get('jsonInput');
        const initiateArray = jsGroup.get('applicantsList');
        this.dependentList.map((item, i) => {
            var _a, _b;
            if (this.fieldConfiguration && this.fieldConfiguration.showPrimaryApplicantToo) {
                item.isPrimaryApplicant = false;
                initiateArray.controls[i].patchValue({
                    isPrimaryApplicant: false,
                });
            }
            else {
                if (item.id === selectedValue.id && ((_b = (_a = this.form.controls['newTaskForm']) === null || _a === void 0 ? void 0 : _a.get('immClassificationCode')) === null || _b === void 0 ? void 0 : _b.value) != 'AFFDVTSUPT864') {
                    item.isPrimaryApplicant = true;
                    initiateArray.controls[i].patchValue({
                        isPrimaryApplicant: true,
                    });
                }
                else {
                    item.isPrimaryApplicant = false;
                    initiateArray.controls[i].patchValue({
                        isPrimaryApplicant: false,
                    });
                }
            }
        });
        // this.addFilingThisFormControl();
    }
    handleSwitchChange() {
        if (this.form.controls['subTask'].get('isOutsideImagility').value) {
            if (this.form.controls['newTaskForm'].get('taskType').value === 'NONIMMPET') {
                this.form.controls['subTask'].patchValue({
                    taskTypeCode: 'PETITION'
                });
            }
            else {
                this.vdSubTaskH4Service
                    .getSubTaskTypeListForFamilyImmigration('IMMPET', this.form.controls['newTaskForm'].get('immCategoryCode').value, this.form.controls['newTaskForm'].get('immClassificationCode').value)
                    .pipe(take(1))
                    .subscribe((response) => {
                    if (response) {
                        this.subTaskType = response;
                        this.subTaskType = [...new Map(this.subTaskType.map(item => [item['code'], item])).values()];
                    }
                });
            }
        }
    }
    handleSpouseSwitchChange() {
        this.showFillingFormSection = this.form.get('jsonInput.isSpouseChildPetitionInclude').value ? true : false;
    }
    getSubTaskType() {
        this.form.patchValue({
            taskTypeCode: null,
        });
        if (this.superTaskTypeCode || 'NONIMMPET') {
            this.apiService.getSubTasksType(this.superTaskTypeCode ? this.superTaskTypeCode : 'NONIMMPET')
                .subscribe((response) => {
                var _a;
                if ((this.userType === 'Petitioner' ||
                    this.userType === 'Attorney') ||
                    (this.form.get('visaType') &&
                        ['TN1', 'TN2'].includes(this.form.get('visaType').value))) {
                    response = response.filter(ele => ele.code !== 'RFE');
                }
                this.subTaskType = response;
                if (!((_a = this.form.get('subTask').get('isOutsideImagility')) === null || _a === void 0 ? void 0 : _a.value)) {
                    this.form.patchValue({
                        taskTypeCode: 'PETITION'
                    });
                }
                if (this.subTaskDetails && this.subTaskDetails.subTaskTypeCode) {
                    //  this.showSubTaskTypeInReadOnly = ['EB4IMMOTH', 'EB4IMMJUVNL', 'EB4IMMRELGWRKR','APPLADCARDIMM','APPLADCARDNONIM','EB5IMMPETBYREGINV','EB5IMMPETBYSTANDINV','EB5829','TEMPPROTSTATI821','DACAI821D'].includes(this.subTaskDetails.taskTypeDetails.immClassificationCode);
                    this.form.get('subTask.taskTypeCode').setValue(this.subTaskDetails.subTaskTypeCode);
                    this.form.get('subTask.taskTypeCode').updateValueAndValidity();
                }
            });
        }
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    getBeneficiaryList(companyId) {
        this.vdSubTaskH4Service.getBeneficiariesByCompanyId(companyId).subscribe((data) => {
            if (data) {
                this.beneficiaryList = data;
            }
        });
    }
    notifyBeneficiary() {
        const beneId = this.form.controls['newTaskForm'].controls['beneficiaryId'].value;
        const visaName = this.form.controls['newTaskForm'].controls['visaType'].value;
        const beneficiary = this.beneficiaryList.find(x => x.beneficiaryEmployeeId === beneId);
        const ref = this.dialogService.open(SendNotificationComponent, {
            width: '70%',
            contentStyle: {
                'max-height': '95vh',
                'z-index': '1000',
                'padding-bottom': '15px',
                'overflow-y': 'hidden'
            },
            closable: false,
            showHeader: false,
            closeOnEscape: false,
            modal: true,
            dismissableMask: true,
            data: {
                visaName,
                beneficiary: {
                    name: `${beneficiary.beneficiaryEmployeeFName} ${beneficiary.beneficiaryEmployeeLName}`,
                    type: 'BENEFICIARY',
                    employeeId: beneficiary.beneficiaryEmployeeId,
                    companyId: beneficiary.companyId
                }
            }
        });
    }
    visitBeneficiaryProfile() {
        sessionStorage.setItem('listBeneficiaryId', `${this.form.controls['newTaskForm'].controls['beneficiaryId'].value}`);
        sessionStorage.setItem('bene-profile-viewMode', 'false');
        let url;
        if (this.userType === RolesRouteMap.PETITIONER) {
            url = `${RolesRouteMap.userRoleRouteMapping[this.userType]}/beneficiaries/profile`;
        }
        else if (this.userType === RolesRouteMap.ATTORNEY) {
            url = `${RolesRouteMap.userRoleRouteMapping[this.userType]}/attorney/beneficiary/profile`;
        }
        this.router.navigate([]).then(() => {
            window.open(url, '_blank');
        });
    }
    onChangeNoOfApplicant(type) {
        if (type === 'single') {
            const jsGroup = this.form.get('jsonInput');
            this.dependentList.forEach((item, i) => {
                var _a, _b;
                if (jsGroup.get('applicantsList').get(`${i}`) && !jsGroup.get('applicantsList').get(`${i}`).get('isPrimaryApplicant').value) {
                    (_b = (_a = jsGroup.get('applicantsList').get(`${i}`)) === null || _a === void 0 ? void 0 : _a.get('isChecked')) === null || _b === void 0 ? void 0 : _b.setValue(false);
                }
            });
        }
        this.showFillingFormSection = (type === 'multiple') ? true : false;
    }
    isDuplicatedtoggle(param, e) {
        if (param === 'duplicated') {
            this.apiService.isAutoPopulateTemplate.next(e);
            if (e) {
                sessionStorage.removeItem('isDuplicated');
            }
        }
        else {
            this.vdSubTaskH4Service.isPetitionOutsideImagility.next(e);
        }
    }
}
VdSubTaskH4Component.ɵfac = function VdSubTaskH4Component_Factory(t) { return new (t || VdSubTaskH4Component)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(i2.CommonQuetionsService), i0.ɵɵdirectiveInject(VdSubTaskH4Service), i0.ɵɵdirectiveInject(i1$1.FormGroupDirective), i0.ɵɵdirectiveInject(i4.Router), i0.ɵɵdirectiveInject(i5.DialogService)); };
VdSubTaskH4Component.ɵcmp = i0.ɵɵdefineComponent({ type: VdSubTaskH4Component, selectors: [["vd-sub-task-h4"]], inputs: { superTaskTypeCode: "superTaskTypeCode", fieldConfiguration: "fieldConfiguration", subTaskDetails: "subTaskDetails" }, features: [i0.ɵɵProvidersFeature([], [
            { provide: ControlContainer, useExisting: FormGroupDirective },
        ])], decls: 6, vars: 6, consts: [["class", "p-fluid p-formgrid p-grid", 4, "ngIf"], ["class", "p-grid dashed-line p-my-4 mx-1", 4, "ngIf"], ["class", "", 4, "ngIf"], ["style", "padding-left: 45px;", "formGroupName", "subTask", 4, "ngIf"], ["style", "padding-left: 45px;", "formGroupName", "jsonInput", 4, "ngIf"], [1, "p-fluid", "p-formgrid", "p-grid"], [1, "p-col-11", "ml-4", "pl-4"], [1, "label-large-bold"], [1, "sub-task-type-text"], [1, "p-grid", "dashed-line", "p-my-4", "mx-1"], [1, ""], [1, "p-text-bold", "pl-3"], [1, "p-grid", "p-my-2", "px-3"], ["name", "question", 1, "p-col-9"], [1, "p-col-1"], ["name", "", 3, "disabled", "checked", "change"], ["class", "p-grid p-my-2 px-3", 4, "ngIf"], ["formGroupName", "subTask", 2, "padding-left", "45px"], [1, "p-text-bold"], ["class", "p-fluid p-formgrid p-grid px-3 pt-2 pb-3", 4, "ngIf"], [1, "p-fluid", "p-formgrid", "p-grid", "px-3", "pt-2", "pb-3"], [1, "p-col-4"], ["for", "tasktype", 1, "create-task-label", "mb-0", "required"], ["inputId", "tasktype", "formControlName", "taskTypeCode", "placeholder", "Select Task Type", "optionLabel", "name", "optionValue", "code", 3, "options"], ["formGroupName", "jsonInput", 2, "padding-left", "45px"], [4, "ngIf"], [1, "create-task-label", "required"], ["formControlName", "primaryApplicant", "name", "primaryApplicant", "optionLabel", "displayName", "placeholder", "Select Applicant", 3, "options", "onChange"], ["class", "p-col-8 align-self-end", 4, "ngIf"], ["class", "p-error", 4, "ngIf"], [1, "p-col-8", "align-self-end"], [1, "create-task-label", "d-block", "mb-0"], [1, "dependant-not-available-actions", 3, "click"], [1, "p-error"], ["class", "p-fluid p-formgrid p-grid mt-2", 4, "ngIf"], [1, "p-fluid", "p-formgrid", "p-grid", "mt-2"], [1, "p-col-6"], [1, "p-formgroup-inline"], [1, "p-field-checkbox"], ["name", "isSingleApplicant", "value", "true", "formControlName", "isSingleApplicant", "inputId", "single", 3, "onClick"], ["for", "single", 1, "create-task-label"], ["name", "isSingleApplicant", "value", "false", "formControlName", "isSingleApplicant", "inputId", "multiple", 3, "onClick"], ["for", "multiple", 1, "create-task-label"], ["name", "question", 1, "p-col-6"], ["class", "p-col-1", 4, "ngIf"], ["formControlName", "isSpouseChildPetitionInclude", 3, "onChange"], ["class", "create-task-label", 4, "ngIf"], ["formArrayName", "applicantsList"], [1, "row", "mt-2", 2, "display", "block"], [4, "ngFor", "ngForOf"], [1, "create-task-label"], [2, "display", "inline-block", 3, "formGroupName"], [1, "pl-2"], ["styleClass", "checkbox-label-allign", "formControlName", "isChecked", "binary", "true", 3, "label", "name", "disabled"]], template: function VdSubTaskH4Component_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, VdSubTaskH4Component_div_0_Template, 8, 1, "div", 0);
        i0.ɵɵtemplate(1, VdSubTaskH4Component_div_1_Template, 1, 0, "div", 1);
        i0.ɵɵtemplate(2, VdSubTaskH4Component_div_2_Template, 9, 1, "div", 2);
        i0.ɵɵtemplate(3, VdSubTaskH4Component_div_3_Template, 1, 0, "div", 1);
        i0.ɵɵtemplate(4, VdSubTaskH4Component_div_4_Template, 4, 1, "div", 3);
        i0.ɵɵtemplate(5, VdSubTaskH4Component_div_5_Template, 3, 2, "div", 4);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.subTaskDetails && (!ctx.isImmigrant || ctx.showSubTaskTypeInReadOnly));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.subTaskDetails);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.subTaskDetails);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.subTaskDetails);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.field.showOutsideImagilityQuestion && !ctx.showSubTaskTypeInReadOnly);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.form == null ? null : ctx.form.get("jsonInput"));
    } }, directives: [i6.NgIf, i7.MatSlideToggle, i1$1.NgControlStatusGroup, i1$1.FormGroupName, i8.Dropdown, i1$1.NgControlStatus, i1$1.FormControlName, i9.RadioButton, i10.InputSwitch, i1$1.FormArrayName, i6.NgForOf, i11.Checkbox], styles: [".dependant-not-available-actions[_ngcontent-%COMP%]{color:#30b1e1!important;cursor:pointer} .p-checkbox-label{line-height:1;margin-top:.5rem}[_nghost-%COMP%]   .mat-slide-toggle.mat-checked[_ngcontent-%COMP%]    .mat-slide-toggle-bar:after{content:\"Yes\";font-size:50%;font-weight:700;color:#fff;position:absolute;left:4px;top:-5px}[_nghost-%COMP%]   .mat-slide-toggle[_ngcontent-%COMP%]:not(.mat-checked)    .mat-slide-toggle-bar:after{content:\"No\";font-size:50%;font-weight:700;color:#fff;position:absolute;left:21px;top:-5px}[_nghost-%COMP%]   .mat-slide-toggle[_ngcontent-%COMP%]   .mat-primary.mat-checked[_ngcontent-%COMP%]   .mat-slide-toggle-thumb[_ngcontent-%COMP%]{background-color:#30b1e1!important}  .mat-slide-toggle.mat-primary.mat-checked:not(.mat-disabled) .mat-slide-toggle-bar,   .mat-slide-toggle.mat-primary.mat-checked:not(.mat-disabled) .mat-slide-toggle-thumb{background-color:#30b1e1}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdSubTaskH4Component, [{
        type: Component,
        args: [{
                selector: 'vd-sub-task-h4',
                templateUrl: 'vd-sub-task-h4.component.html',
                styleUrls: ['vd-sub-task-h4.component.scss'],
                viewProviders: [
                    { provide: ControlContainer, useExisting: FormGroupDirective },
                ]
            }]
    }], function () { return [{ type: i1$1.FormBuilder }, { type: i2.CommonQuetionsService }, { type: VdSubTaskH4Service }, { type: i1$1.FormGroupDirective }, { type: i4.Router }, { type: i5.DialogService }]; }, { superTaskTypeCode: [{
            type: Input
        }], fieldConfiguration: [{
            type: Input
        }], subTaskDetails: [{
            type: Input
        }] }); })();

class VdSubTaskH4Module {
}
VdSubTaskH4Module.ɵfac = function VdSubTaskH4Module_Factory(t) { return new (t || VdSubTaskH4Module)(); };
VdSubTaskH4Module.ɵmod = i0.ɵɵdefineNgModule({ type: VdSubTaskH4Module });
VdSubTaskH4Module.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            ReactiveFormsModule,
            MatSlideToggleModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VdSubTaskH4Module, { declarations: [VdSubTaskH4Component], imports: [PrimengLibraryModule,
        ReactiveFormsModule,
        MatSlideToggleModule], exports: [VdSubTaskH4Component] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdSubTaskH4Module, [{
        type: NgModule,
        args: [{
                declarations: [VdSubTaskH4Component],
                imports: [
                    PrimengLibraryModule,
                    ReactiveFormsModule,
                    MatSlideToggleModule
                ],
                exports: [VdSubTaskH4Component]
            }]
    }], null, null); })();

/*
 * Public API Surface of vd-sub-task-h4
 */

/**
 * Generated bundle index. Do not edit.
 */

export { VdSubTaskH4Component, VdSubTaskH4Module, VdSubTaskH4Service };
//# sourceMappingURL=vd-sub-task-h4.js.map
